module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.value) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('model-scenario-chooser', {
    ref: "scenarioChooser",
    model: {
      value: (_vm.value.modelInfo),
      callback: function($$v) {
        _vm.$set(_vm.value, "modelInfo", $$v)
      },
      expression: "value.modelInfo"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onOkClick
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v("Cancel")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4491c7cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4491c7cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/paste-nodes-options-dialog/paste-nodes-options-dialog.vue.html
// module id = 1101
// module chunks = 0